import SectionTitle from "../components/SectionTitle";
import SkillCard from "../components/SkillCard";
import SubTitle from "../components/SubTitle";
import { motion } from "framer-motion";
import SkillsIcon from "../components/icons/SkillsIcon";
import { mySkills } from "../data/skills-data";

export default function SkillsSection() {
  return (
    <motion.section
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="w-full py-5 px-3 sm:px-5"
      id="skills"
    >
      <SectionTitle title="skills">
        <SkillsIcon />
      </SectionTitle>
      {mySkills.map(({ scopeTitle, skills }) => (
        <SkillCategory key={scopeTitle} title={scopeTitle} skills={skills} />
      ))}
    </motion.section>
  );
}

function SkillCategory({ title, skills }) {
  return (
    <>
      <SubTitle title={title} />
      <div className="flex flex-wrap justify-center gap-2">
        {skills.map(({ logo: Logo, title }) => (
          <SkillCard key={title} logo={<Logo />} title={title} />
        ))}
      </div>
    </>
  );
}
